/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Conflict_Reason_Maybe_HintInputs */

const cs_ebr_conflict_reason_maybe_hint = /** @type {(inputs: Ebr_Conflict_Reason_Maybe_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chybí záznam posledního importu, hodnotu v CRM nelze ověřit. Bez vaší volby zůstane hodnota z CRM.`)
};

const en_ebr_conflict_reason_maybe_hint = /** @type {(inputs: Ebr_Conflict_Reason_Maybe_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No last-import record, the CRM value cannot be verified. Without your choice the CRM value is kept.`)
};

/**
* | output |
* | --- |
* | "No last-import record, the CRM value cannot be verified. Without your choice the CRM value is kept." |
*
* @param {Ebr_Conflict_Reason_Maybe_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_conflict_reason_maybe_hint = /** @type {((inputs?: Ebr_Conflict_Reason_Maybe_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Conflict_Reason_Maybe_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_conflict_reason_maybe_hint(inputs)
	return cs_ebr_conflict_reason_maybe_hint(inputs)
});